import { render, staticRenderFns } from "./LogsPage.vue?vue&type=template&id=74c525e5&scoped=true&lang=pug&"
import script from "./LogsPage.vue?vue&type=script&lang=ts&"
export * from "./LogsPage.vue?vue&type=script&lang=ts&"
import style0 from "./LogsPage.vue?vue&type=style&index=0&id=74c525e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c525e5",
  null
  
)

export default component.exports